export default {"src":"/_next/static/media/linkedin-logo.d0f6cf4b.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};